<template>
  <div id="app">
    <el-container v-if="$route.path !== '/login'" style="height: 100vh">
      <!-- 移动端遮罩层 -->
      <div
        v-if="isMobile && sidebarVisible"
        class="mobile-overlay"
        @click="closeSidebar"
      ></div>

      <!-- 侧边栏 -->
      <el-aside
        :width="isMobile ? '250px' : '250px'"
        :class="{
          'mobile-sidebar': isMobile,
          'sidebar-hidden': isMobile && !sidebarVisible,
        }"
        style="background-color: #304156"
      >
        <div
          class="logo"
          style="
            padding: 20px;
            text-align: center;
            color: white;
            font-size: 18px;
            font-weight: bold;
          "
        >
          PDF生成系统
        </div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router
          @select="handleMenuSelect"
        >
          <el-menu-item index="/dashboard">
            <el-icon><House /></el-icon>
            <span>仪表板</span>
          </el-menu-item>
          <el-menu-item index="/generate1">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF1</span>
          </el-menu-item>
          <el-menu-item index="/generate2">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF2</span>
          </el-menu-item>
          <el-menu-item index="/generate3">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF3</span>
          </el-menu-item>
          <el-menu-item index="/generate4">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF4</span>
          </el-menu-item>
          <el-menu-item index="/generate5">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF5</span>
          </el-menu-item>
          <el-menu-item index="/generate6">
            <el-icon><DocumentAdd /></el-icon>
            <span>生成PDF6</span>
          </el-menu-item>
          <el-menu-item index="/pdfs">
            <el-icon><Document /></el-icon>
            <span>我的PDF</span>
          </el-menu-item>
          <el-menu-item v-if="isAdmin" index="/users">
            <el-icon><User /></el-icon>
            <span>用户管理</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 主内容区 -->
      <el-container>
        <!-- 顶部导航 -->
        <el-header class="app-header">
          <div class="header-left">
            <el-button
              v-if="isMobile"
              type="text"
              class="menu-toggle"
              @click="toggleSidebar"
            >
              <el-icon size="20"><Menu /></el-icon>
            </el-button>
            <h2 class="page-title">{{ getPageTitle() }}</h2>
          </div>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <el-icon><Avatar /></el-icon>
              <span v-if="!isMobile">用户菜单</span>
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-header>

        <!-- 主内容 -->
        <el-main style="background-color: #f0f2f5; padding: 20px">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <!-- 登录页面 -->
    <router-view v-else />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";

export default {
  name: "App",
  setup() {
    const router = useRouter();
    const route = useRoute();

    const isAdmin = ref(false);
    const isMobile = ref(false);
    const sidebarVisible = ref(false);

    // 检测移动端
    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 768;
      if (!isMobile.value) {
        sidebarVisible.value = false;
      }
    };

    // 初始化时检查管理员状态和移动端
    onMounted(() => {
      isAdmin.value = localStorage.getItem("isAdmin") === "true";
      checkMobile();
      window.addEventListener("resize", checkMobile);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", checkMobile);
    });

    // 监听路由变化，更新管理员状态
    router.afterEach(() => {
      isAdmin.value = localStorage.getItem("isAdmin") === "true";
      // 移动端路由切换时关闭侧边栏
      if (isMobile.value) {
        sidebarVisible.value = false;
      }
    });

    const getPageTitle = () => {
      const titles = {
        "/dashboard": "仪表板",
        "/generate1": "生成PDF1",
        "/generate2": "生成PDF2",
        "/generate3": "生成PDF3",
        "/generate4": "生成PDF4",
        "/generate5": "生成PDF5",
        "/generate6": "生成PDF6",
        "/pdfs": "我的PDF",
        "/users": "用户管理",
      };
      return titles[route.path] || "PDF生成系统";
    };

    const toggleSidebar = () => {
      sidebarVisible.value = !sidebarVisible.value;
    };

    const closeSidebar = () => {
      sidebarVisible.value = false;
    };

    const handleMenuSelect = () => {
      // 移动端选择菜单项后关闭侧边栏
      if (isMobile.value) {
        sidebarVisible.value = false;
      }
    };

    const handleCommand = (command) => {
      if (command === "logout") {
        localStorage.removeItem("token");
        localStorage.removeItem("isAdmin");
        ElMessage.success("退出登录成功");
        router.push("/login");
      }
    };

    return {
      isAdmin,
      isMobile,
      sidebarVisible,
      getPageTitle,
      toggleSidebar,
      closeSidebar,
      handleMenuSelect,
      handleCommand,
    };
  },
};
</script>

<style>
#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

/* 顶部导航样式 */
.app-header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.page-title {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.menu-toggle {
  padding: 8px;
  color: #666;
}

.menu-toggle:hover {
  color: #409eff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  display: flex;
  align-items: center;
  gap: 5px;
}

.el-dropdown-link:hover {
  color: #66b1ff;
}

/* 移动端样式 */
@media (max-width: 768px) {
  .mobile-sidebar {
    position: fixed !important;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1001;
    transition: transform 0.3s ease;
  }

  .sidebar-hidden {
    transform: translateX(-100%);
  }

  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .app-header {
    padding: 0 15px;
  }

  .page-title {
    font-size: 16px;
  }

  .el-main {
    padding: 15px !important;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .app-header {
    padding: 0 10px;
  }

  .page-title {
    font-size: 14px;
  }

  .el-main {
    padding: 10px !important;
  }
}
</style>
